import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#333",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M12 .75v7.5M15.75 2.25l-3.75 3-3.75-3M2.257 6.375l6.495 3.75M5.43 3.877l.724 4.748-4.473 1.748M2.257 17.625l6.495-3.75M1.68 13.627l4.474 1.748-.723 4.748M12 23.25v-7.5M8.25 21.75l3.75-3 3.75 3M21.743 17.625l-6.495-3.75M18.569 20.123l-.723-4.748 4.473-1.748M21.743 6.375l-6.495 3.75M22.319 10.373l-4.473-1.748.723-4.748M12 8.25l-3.248 1.875v3.75L12 15.75l3.248-1.875v-3.75L12 8.25Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }